export default "__VITE_ASSET__ZdAN4KO___"